export const STORAGE_KEYS = {
  REAL_HOLDINGS:   'vifm-portfolio',
  PRACTICE_STATE:  (userId) => `vifm-practice-${userId}`,
  LEADERBOARD:     'vifm-leaderboard',
  PORTFOLIO_MODE:  'vifm-portfolio-mode',
};
